import React, { Component } from 'react';
import _validator from 'modules/validator';
import _AdminService from 'modules/AdminService';
import DropdownList from 'components/controls/DropdownList';
import _notification from 'modules/notification';
import { Card, Table, Modal, Icon } from 'antd';
import EmptyState from 'components/enterprise/EmptyState';
import PageHeader from 'components/enterprise/PageHeader';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import ButtonComponent from 'components/controls/Button';
import { routesAdmin } from 'routes/Routes';
import ConfirmPopup from '../popup/ConfirmPopup';
import MyInput from 'components/controls/MyInput';
import TextArea from 'components/controls/TextArea';
import { GENERAL_ERROR_MESSAGE } from 'constants/constants';
import ImageToBase64 from '../../components/controls/ImageToBase64';
import FileUpload from '../../components/controls/FileUpload';

class ChallanBankDetailMaster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: { pageSize: 10, current: 1 },
            highlightedRowID: 0,
            data: [],
            exams: [],
            rowData: {},
            loading: false,
            showModel: false,
            showMessageBox: false,
            Account_Name_English_Error: "",
            Account_Name_Marathi_Error: "",
            Account_Number_Error: "",
            Bank_Name_English_Error: "",
            Bank_Name_Marathi_Error: "",
            Subtext_Error: "",
            Note1_Error: "",
            Note2_Error: "",
            Note3_Error: "",
            Exam_Error: "",
            logo1: "",
            logo2: "",
            totalRowCount: 0,
            IFSCCodeError: ""
        };
    }

    componentDidMount() {
        this.getAllSpecialization();
        this.getAllExams();
    }

    //API operations
    getAllSpecialization = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let challanBankDetailsList = await _AdminService.GetChallanBankDetailData();
                    //console.log("categoryList Data: ", challanBankDetailsList.data.Obj);

                    this.setState({
                        ...this.state,
                        data: challanBankDetailsList.data.Obj,
                        totalRowCount: challanBankDetailsList.data.Obj.length,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    getAllExams = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let examsList = await _AdminService.GetAllPost();
                    //console.log("categoryList Data: ", examsList.data);

                    this.setState({
                        ...this.state,
                        exams: examsList.data,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    handleUpdate = async (input) => {
        if (this.validateFormData()) {
            return
        }

        const params = {
            ...this.state.rowData
        }

        //console.log("Final data: ", params);

        try {
            this.setState({ loading: true }, async () => {
                try {
                    const response = await _AdminService.CreateChallanBankDetail(params);
                    //console.log("Post response: ", response);
                    if (response.status == 200) {
                        _notification.showMessage('success', "Challan Bank Details saved successfully.");
                        this.setState({
                            Account_Name_English_Error: "",
                            Account_Name_Marathi_Error: "",
                            Account_Number_Error: "",
                            Bank_Name_English_Error: "",
                            Bank_Name_Marathi_Error: "",
                            Subtext_Error: "",
                            Note1_Error: "",
                            Note2_Error: "",
                            Note3_Error: "",
                            Exam_Error: "",
                            logo1: "",
                            logo2: "",
                            showModel: false,
                            loading: false,
                            highlightedRowID: params.Id,
                            IFSCCodeError:""
                        });
                        this.getAllSpecialization();
                    }
                    else {
                        _notification.showMessage('error', response.data.message);
                    }
                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                    _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                }
            });
        } catch (e) { }
    }

    deletePost = async (value) => {
        try {
            const response = await _AdminService.DeleteChallanBankDetail(this.state.rowData.Id);
            //console.log("Post response: ", response);
            if (response.status == 200 && response.data.IsSuccess) {
                _notification.showMessage('success', "Challan Bank Details deleted successfully.");
                this.setState({
                    Account_Name_English_Error: "",
                    Account_Name_Marathi_Error: "",
                    Account_Number_Error: "",
                    Bank_Name_English_Error: "",
                    Bank_Name_Marathi_Error: "",
                    Subtext_Error: "",
                    Note1_Error: "",
                    Note2_Error: "",
                    Note3_Error: "",
                    Exam_Error: "",
                    logo1: "",
                    logo2: "",
                    showModel: false,
                    IFSCCodeError:""
                });
                this.getAllSpecialization();
            }
            else {
                _notification.showMessage('error', response.data.Message);
            }
        } catch (e) {
            _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
        }
    }

    //Table action link clicks
    onEditClick = (value) => {
        //console.log('params ', value);
        this.setState({ rowData: value, showModel: true, highlightedRowID: 0 });
        window.scrollTo(0, 0);
    };

    onDeleteClick = (value) => {
        //console.log('params ', value);
        this.setState({ rowData: value, showMessageBox: true, highlightedRowID: 0 });
    };

    onTableAction = (pagination, filters, sorter, extra) => {
        //console.log('onTableAction ', pagination,'onFilter ', filters, sorter, extra.currentDataSource.length);        
        this.setState({ pagination: pagination, highlightedRowID: 0, totalRowCount: extra.currentDataSource.length });
    }

    //Message box confirm delete click
    onConfirmDelete = (value) => {
        //console.log('reached in delete:  ', value);
        this.setState({ showMessageBox: false });
        this.deletePost(value);
    }

    closeMessageBox(value = false) {
        this.setState({ showMessageBox: value });
    }

    // Add new record click
    onAddNewRecordClick(modelToggle) {
        this.setState({ showModel: modelToggle, rowData: {} });
    }

    hideModelWindow() {
        this.setState({
            showModel: false, 
            rowData: {}, 
            Account_Name_English_Error: "",
            Account_Name_Marathi_Error: "",
            Account_Number_Error: "",
            Bank_Name_English_Error: "",
            Bank_Name_Marathi_Error: "",
            Subtext_Error: "",
            Note1_Error: "",
            Note2_Error: "",
            Note3_Error: "",
            Exam_Error: "",
            logo1: "",
            logo2: "",
            IFSCCodeError:""
        });
    }

    onTextChange = ({ target: { name, value } }) => {
        if (name == 'Account_Number' && isNaN(value))
            return;

            if (name == 'Account_Name_English' && value.length > 100)
            return;

            if (name == 'Account_Name_Marathi' && value.length > 100)
            return;

            if (name == 'Bank_Name_English' && value.length > 100)
            return;

            if (name == 'Bank_Name_Marathi' && value.length > 100)
            return;

            if (name == 'Account_Number' && value.length > 20)
            return;

            if (name == 'Subtext' && value.length > 400)
            return;

            if (name == 'Note1' && value.length > 500)
            return;

            if (name == 'Note2' && value.length > 500)
            return;

            if (name == 'Note3' && value.length > 500)
            return;

            if (name == 'IFSCCode' && value.length > 20)
            return;

        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, [name]: value }
        });
    }

    onExamChange = (event) => {
        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, [event.target.name]: event.target.value }
        });
    }

    validateFormData = () => {
        let body = this.state.rowData;

        this.setState({
            Account_Name_English_Error: "",
            Account_Name_Marathi_Error: "",
            Account_Number_Error: "",
            Bank_Name_English_Error: "",
            Bank_Name_Marathi_Error: "",
            Subtext_Error: "",
            Note1_Error: "",
            Note2_Error: "",
            Note3_Error: "",
            Exam_Error: "",
            IFSCCodeError:""
        });

        //console.log("Validate: ", body);

        let hasError = false;

        if (!body.Account_Name_English || !body.Account_Name_English.trim()) {
            this.setState({ Account_Name_English_Error: 'Please enter valid Account Name English' });
            hasError = true
        }

        if (!body.Account_Name_Marathi || !body.Account_Name_Marathi.trim()) {
            this.setState({ Account_Name_Marathi_Error: 'Please enter valid Account Name Marathi' });
            hasError = true
        }

        if (!body.Account_Number) {
            this.setState({ Account_Number_Error: 'Please enter valid Account Number' });
            hasError = true
        }

        if (!body.Bank_Name_English || !body.Bank_Name_English.trim()) {
            this.setState({ Bank_Name_English_Error: 'Please enter valid Bank Name English' });
            hasError = true
        }

        if (!body.Bank_Name_Marathi || !body.Bank_Name_Marathi.trim()) {
            this.setState({ Bank_Name_Marathi_Error: 'Please enter valid Bank Name Marathi' });
            hasError = true
        }

        if (!body.Subtext || !body.Subtext.trim()) {
            this.setState({ Subtext_Error: 'Please enter valid Subtext' });
            hasError = true
        }

        if (!body.Note1 || !body.Note1.trim()) {
            this.setState({ Note1_Error: 'Please enter valid Note1' });
            hasError = true
        }

        if (!body.Note2 || !body.Note2.trim()) {
            this.setState({ Note2_Error: 'Please enter valid Note2' });
            hasError = true
        }

        if (!body.Note3 || !body.Note3.trim()) {
            this.setState({ Note3_Error: 'Please enter valid Note3' });
            hasError = true
        }

        if (!body.PostId) {
            this.setState({ Exam_Error: 'Please select Post/Exam' });
            hasError = true
        }

        if (!body.Bank_Image_Path) {
            this.setState({ logo1: 'Please select Bank Image Path' });
            hasError = true
        }

        if (!body.Bank_Logo_Path) {
            this.setState({ logo2: 'Please select Bank Logo Path' });
            hasError = true
        }

        if (!body.IFSCCode || !body.IFSCCode.trim()) {
            this.setState({ IFSCCodeError: 'Please enter valid IFSCCode' });
            hasError = true
        }

        return hasError;
    }

    onLogoOneSelect = (data) => {
        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, ["Bank_Image_Path"]: data }
        });
    }

    onLogoTwoSelect = (data) => {
        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, ["Bank_Logo_Path"]: data }
        });
    }

    render() {
        const TableColumns = [
            {
                title: 'Post/Exam Name',
                dataIndex: 'PostName',
                width: '10%',
                key: 'PostName',
            },
            {
                title: 'Account Name English',
                dataIndex: 'Account_Name_English',
                width: '18%',
                key: 'Account_Name_English',
            },
            {
                title: 'Account Name Marathi',
                dataIndex: 'Account_Name_Marathi',
                width: '15%',
                key: 'Account_Name_Marathi',
            },
            {
                title: 'Account Number',
                dataIndex: 'Account_Number',
                width: '12%',
                key: 'Account_Number',
            },
            {
                title: 'Bank Name English',
                dataIndex: 'Bank_Name_English',
                width: '12%',
                key: 'Bank_Name_English',
            },
            {
                title: 'Bank Name Marathi',
                dataIndex: 'Bank_Name_Marathi',
                width: '12%',
                key: 'Bank_Name_Marathi',
            },
            {
                title: 'IFSCCode',
                dataIndex: 'IFSCCode',
                width: '20%',
                key: 'IFSCCode',
            }, 
            {
                title: 'Subtext',
                dataIndex: 'Subtext',
                width: '20%',
                key: 'Subtext',
            },            
            {
                title: 'Action',
                dataIndex: '',
                key: 'Id',
                render: (value) => {
                    return (
                        <>
                            <ButtonComponent type="button" value="Edit" className="button-global button-border small autoHeight mr-2" onClick={(event) => this.onEditClick(value)} />
                            <ButtonComponent type="button" value="Delete" className="button-global button-danger small autoHeight" onClick={(event) => this.onDeleteClick(value)} />
                        </>
                    );
                },
                fixed: 'right',
            },
        ];

        if (this.state.loading)
            return <LoadingSpinner />

        return (
            <div className="container-fluid p-3">
                <PageHeader
                    title="Challan Bank Detail Master"
                    breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Challan Bank Detail Master' }]}
                />
                <div className="analysisWrap">
                    <div style={{ textAlign: 'right' }}>
                        {!this.state.showModel &&
                            <div className="max1200 m-auto mb-2"> 
                                <div className="d-flex align-items-center justify-content-end">
                                    <a className="button-global button-border addbutton large   d-inline-block text-center autoHeight mb-3 d-flex align-items-center justify-content-center" 
                                    onClick={() => this.onAddNewRecordClick(true)}><Icon type="plus-circle" className="mr-2 font1rem" /> Add Challan Bank Details</a>
                        
                                </div>
                            </div>
                        }
                    </div>
                    {/* Modal controls */}
                    {this.state.showModel && 
                        <div className="max1200 m-auto">
                            <div className="ent-panel">
                                <h4 className="heading4">{this.state.rowData ? this.state.rowData.Id > 0 ? "Update" : "Add" : "Add"} Challan Bank Details </h4>
                                <div className="admin-inner-wrap p-3">
                                    <div className="row flex-sm-row pb-3">
                                        <div className="mb-2 col-sm-4">
                                            <MyInput id="Account_Name_English"
                                                type="text"
                                                key="Account_Name_English"
                                                name="Account_Name_English"
                                                heading="Account Name English"
                                                value={this.state.rowData.Account_Name_English ? this.state.rowData.Account_Name_English : ""}
                                                onChange={this.onTextChange}
                                                isRequired={true}
                                                errorState={this.state.Account_Name_English_Error}
                                                errorMessage={this.state.Account_Name_English_Error} />
                                        </div>
                                        <div className="mb-2 col-sm-4">
                                            <MyInput id="Account_Name_Marathi"
                                                type="text"
                                                key="Account_Name_Marathi"
                                                name="Account_Name_Marathi"
                                                heading="Account Name Marathi"
                                                value={this.state.rowData.Account_Name_Marathi ? this.state.rowData.Account_Name_Marathi : ""}
                                                onChange={this.onTextChange}
                                                isRequired={true}
                                                errorState={this.state.Account_Name_Marathi_Error}
                                                errorMessage={this.state.Account_Name_Marathi_Error} />
                                        </div>
                                        <div className="mb-2 col-sm-4">
                                            <MyInput id="Account_Number"
                                                type="text"
                                                key="Account_Number"
                                                name="Account_Number"
                                                heading="Account Number"
                                                value={this.state.rowData.Account_Number ? this.state.rowData.Account_Number : ""}
                                                onChange={this.onTextChange}
                                                isRequired={true}
                                                errorState={this.state.Account_Number_Error}
                                                errorMessage={this.state.Account_Number_Error} />
                                        </div>
                                    </div>
                                    <div className="row flex-sm-row pb-3">
                                        <div className="mb-2 col-sm-4">
                                            <MyInput id="Bank_Name_English"
                                                type="text"
                                                key="Bank_Name_English"
                                                name="Bank_Name_English"
                                                heading="Bank Name English"
                                                value={this.state.rowData.Bank_Name_English ? this.state.rowData.Bank_Name_English : ""}
                                                onChange={this.onTextChange}
                                                isRequired={true}
                                                errorState={this.state.Bank_Name_English_Error}
                                                errorMessage={this.state.Bank_Name_English_Error} />
                                        </div>
                                        <div className="mb-2 col-sm-4">
                                            <MyInput id="Bank_Name_Marathi"
                                                type="text"
                                                key="Bank_Name_Marathi"
                                                name="Bank_Name_Marathi"
                                                heading="Bank Name Marathi"
                                                value={this.state.rowData.Bank_Name_Marathi ? this.state.rowData.Bank_Name_Marathi : ""}
                                                onChange={this.onTextChange}
                                                isRequired={true}
                                                errorState={this.state.Bank_Name_Marathi_Error}
                                                errorMessage={this.state.Bank_Name_Marathi_Error} />
                                        </div>
                                        <div className="mb-2 col-sm-4">
                                            <MyInput id="Subtext"
                                                type="text"
                                                key="Subtext"
                                                name="Subtext"
                                                heading="Subtext"
                                                value={this.state.rowData.Subtext ? this.state.rowData.Subtext : ""}
                                                onChange={this.onTextChange}
                                                isRequired={true}
                                                errorState={this.state.Subtext_Error}
                                                errorMessage={this.state.Subtext_Error} />
                                        </div>
                                    </div>
                                    <div className="row flex-sm-row ">
                                        <div className="mb-2 col-sm-4">
                                            <MyInput id="IFSCCode"
                                                type="text"
                                                key="IFSCCode"
                                                name="IFSCCode"
                                                heading="IFSC Code"
                                                value={this.state.rowData.IFSCCode ? this.state.rowData.IFSCCode : ""}
                                                onChange={this.onTextChange}
                                                isRequired={true}
                                                errorState={this.state.IFSCCodeError}
                                                errorMessage={this.state.IFSCCodeError} />
                                        </div>
                                        <div className="mb-2 col-sm-8">
                                            <label htmlFor="Note1" className="card-holder-name">Note1<span className="color-red">*</span></label>
                                            <TextArea id="Note1"
                                                type="text"
                                                key="Note1"
                                                name="Note1"
                                                rows="4"
                                                value={this.state.rowData.Note1 ? this.state.rowData.Note1 : ""}
                                                onChange={this.onTextChange}
                                                isRequired={false}
                                                errorState={this.state.Note1_Error}
                                                errorMessage={this.state.Note1_Error} />
                                        </div>
                                    </div>
                                    <div className="row flex-sm-row ">
                                        <div className="mb-2 col-sm-6">
                                            <label htmlFor="Note2" className="card-holder-name">Note2<span className="color-red">*</span></label>
                                            <TextArea id="Note2"
                                                type="text"
                                                key="Note2"
                                                name="Note2"
                                                rows="4"
                                                value={this.state.rowData.Note2 ? this.state.rowData.Note2 : ""}
                                                onChange={this.onTextChange}
                                                isRequired={false}
                                                errorState={this.state.Note2_Error}
                                                errorMessage={this.state.Note2_Error} />
                                        </div>
                                        <div className="mb-2 col-sm-6">
                                            <label htmlFor="Note3" className="card-holder-name">Note3<span className="color-red">*</span></label>
                                            <TextArea id="Note3"
                                                type="text"
                                                key="Note3"
                                                name="Note3"
                                                rows="4"
                                                value={this.state.rowData.Note3 ? this.state.rowData.Note3 : ""}
                                                onChange={this.onTextChange}
                                                isRequired={false}
                                                errorState={this.state.Note3_Error}
                                                errorMessage={this.state.Note3_Error} />
                                        </div>
                                    </div>

                                    <div className="row flex-sm-row pb-3">
                                        <div className="col-sm-4">
                                            <DropdownList
                                                value={this.state.rowData.PostId ? this.state.rowData.PostId : 0}
                                                name="PostId"
                                                onChange={this.onExamChange}
                                                placeholder="Select Exam"
                                                heading={"Exam/Post"}
                                                className="w-100"
                                                wrapClass="wrap"
                                                isRequired={true}
                                                options={this.state.exams}
                                                errorState={this.state.Exam_Error}
                                                errorMessage={this.state.Exam_Error}
                                            />
                                        </div>
                                    </div>

                                    <div className="row flex-sm-row pb-3">
                                        <div className="col-sm-4">
                                            <label htmlFor="category">Bank Image Path<span className="color-red">*</span></label>
                                            <Card className='textAlignCenter uploadCard ' style={this.state.logo1 ? { borderColor: 'red', borderWidth: '2px' } : {}}>
                                                {this.state.rowData.Bank_Image_Path && <img src={this.state.rowData.Bank_Image_Path} alt="Logo not set" className='challanLogoStyle' />}
                                                <ImageToBase64 onSelect={this.onLogoOneSelect} selectText="Select" removeText={this.state.rowData.Bank_Image_Path ? "Remove" : ""} logoFor="logo1"></ImageToBase64>
                                            </Card>
                                        </div>
                                        <div className="col-sm-4">
                                            <label htmlFor="category">Bank Logo Path<span className="color-red">*</span></label>
                                            <Card className='textAlignCenter uploadCard ' style={this.state.logo1 ? { borderColor: 'red', borderWidth: '2px' } : {}}>
                                                {this.state.rowData.Bank_Logo_Path && <img src={this.state.rowData.Bank_Logo_Path} alt="Logo not set" className='challanLogoStyle' />}
                                                <ImageToBase64 onSelect={this.onLogoTwoSelect} selectText="Select" removeText={this.state.rowData.Bank_Logo_Path ? "Remove" : ""} logoFor="logo2"></ImageToBase64>
                                            </Card>
                                        </div>
                                    </div>
                                    
                                </div>
                                <div className="pt-4 buttonAlignCenter" >
                                    <ButtonComponent type="button" value="Cancel" onClick={() => this.hideModelWindow()} className="button-global button-secondary mr-4 autoHeight small" />
                                    <ButtonComponent type="button" value="Save" onClick={this.handleUpdate} className="button-global button-primary autoHeight small" disabled={this.state.loading} />
                                </div>
                            </div>           
                        </div>    
                    } 
                    <div className="max1200 m-auto"> 
                        <Table size='small'
                            bordered
                            rowKey='Id'
                            columns={TableColumns}
                            dataSource={this.state.data}
                            pagination={this.state.pagination}
                            footer={() => <label style={{ textAlign: 'right', marginRight: '20px' }}>Total Records: {this.state.totalRowCount}</label>}
                            onChange={this.onTableAction}
                            rowClassName={(record, index) => (index % 2 ? 'odd' + (record.Id === this.state.highlightedRowID ? 'scroll-row table-row-dark' : '') :
                                'even' + (record.Id === this.state.highlightedRowID ? 'scroll-row table-row-dark' : ''))}
                            className="table-striped-rows admin-table"
                            locale={{ emptyText: <EmptyState icon="inbox" title="No Records Found" description="No challan bank details have been added yet." /> }}
                        />
                    </div>
                </div>   

                <Modal
                    centered={true}
                    width={400}
                    // bodyStyle={{
                    //     height: "150px",
                    //     padding: 0,
                    //     alignItems: "center",
                    //     justifyContent: "center",
                    //     display: " flex"
                    // }}
                    className="modelPopAnt admin-home"
                    visible={this.state.showMessageBox}
                    onCancel={() => this.closeMessageBox(false)}
                    footer={false}
                >
                    <ConfirmPopup
                        onCancel={() => this.closeMessageBox(false)}
                        onOk={this.onConfirmDelete}
                        popupData={this.state.rowData}
                        message="Are you sure, you want to delete this Challan Bank Details?"
                    />
                </Modal>
            </div>
        )
    };
}

export default ChallanBankDetailMaster;